import styled, { css } from "styled-components";
import { colorMixin, hexToRGBA, typographyMixin } from "../../../helpers";

export const SelectedOption = styled.div`
    box-sizing: border-box;
    margin: 0;
    gap: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: ${({ theme }) => theme.v2.colors["text-primary-1200"]};
    ${typographyMixin("label-small-regular")}
`;

export const DropdownItem = styled.div<{ isActive?: boolean; subgroup?: boolean }>`
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 12px;
    ${({ onClick }) => onClick && "cursor: pointer;"}
    ${typographyMixin("label-small-regular")}
    color: ${colorMixin("text-primary-1200")};

    :hover {
        background: ${colorMixin("surface-50")};
    }

    ${({ theme, isActive }) => css`
        ${isActive &&
        css`
            background: ${theme.v2.colors["surface-50"]};
        `}
    `}
`;

export const OptionsGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin: 1px 0;

    ${({ theme }) => css`
        border-radius: 0.5em;
        background-color: ${hexToRGBA(theme.v2.colors["background-secondary-600"], 0.5)};
        padding: calc(0.5em - 0.15em - 1px);
    `}
`;

export const ContentWrapper = styled.div`
    display: flex;
    gap: 4px;
    flex-wrap: nowrap;
    width: 100%;
`;

export const ClearWrapper = styled.div`
    display: flex;
    position: absolute;
    right: 32px;
`;
